import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IPhone} from '../model/interface/phone.model.interface';
import {CustomerPhoneService} from '../../core/services/customer-phone.service';
import {EventBusService} from '../../core/services/event-bus.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DictionaryPosition} from '../model/dictionary.model';
import {CustomValidators} from '../validator/customValidators';
import {ISimpleSelectableDataList} from "../model/interface/simple-selectable-data.model.interface";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-customer-phone',
  templateUrl: './customer-phone.component.html',
  styleUrls: ['./customer-phone.component.css']
})
export class CustomerPhoneComponent implements OnInit {
  @Input() phone: IPhone;
  @Output() eventDelete = new EventEmitter<IPhone>();
  phoneForm: FormGroup;
  statuses: ISimpleSelectableDataList;

  constructor(private customerPhoneService: CustomerPhoneService,
              private eventBusService: EventBusService) {
  }

  ngOnInit(): void {
    this.createForm();
    this.fetchStatuses();
  }

  editPhone() {
    return this.customerPhoneService.edit(this.phone.id, this.phoneForm.value)
      .subscribe(() => this.eventBusService.display(DictionaryPosition.OK));
  }

  deletePhone() {
    this.customerPhoneService.delete(this.phone.id)
      .subscribe(() => {
        this.eventDelete.next(this.phone);
        this.eventBusService.display(DictionaryPosition.OK);
      });
  }

  private createForm() {
    this.phoneForm = new FormGroup({
      phone: new FormControl(this.phone.phone, CustomValidators.phoneValidator),
      statusId: new FormControl(this.phone.status.id, Validators.required)
    });
  }


  private fetchStatuses() {
    this.customerPhoneService.getStatuses()
      .pipe(
        map(list => list.toSimpleSelectableDataList())
      )
      .subscribe(list => this.statuses = list);
  }

}
